const atgProductContent = {
  productFeatureSpecs: {
    features: 'Features',
    specifications: 'Specifications',
    readMore: 'Read More',
    readLess: 'Read Less',
  },
};

export const atgProduct = {
  ...atgProductContent,
  atgProduct: atgProductContent,
};
